import { Icon, type IconGlyphProps } from 'BomdisoftComponents/icons/base';
import { CHEVRON_RIGHT_GLYPH } from 'BomdisoftComponents/icons/glyphs';

export const ChevronRightIcon = (props: IconGlyphProps) => <Icon {...props} glyph={CHEVRON_RIGHT_GLYPH} />;
